import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from "react";
import { ReactPageLayoutStrategy } from "../ReactPageLayout/ReactPageLayoutStrategy";
import { LayoutIdContext } from "./LayoutIdContext";
import { useLayout } from "./useLayout";
/**
 * Display configuration or sub configuration
 */
export function LayoutStrategyWithFallback(props) {
    const { FallbackStrategy = Fragment, LoadingIndicator = Fragment, layoutId, } = props;
    const { isReady, layout } = useLayout({ layoutId });
    if (!isReady) {
        // display loading indicator while loading
        return _jsx(LoadingIndicator, {});
    }
    if (!layout) {
        // fallback to simple layout
        return _jsx(FallbackStrategy, {});
    }
    // display the react page layout
    return (_jsx(LayoutIdContext.Provider, { value: layoutId, children: _jsx(ReactPageLayoutStrategy, { layout: layout }) }));
}
//# sourceMappingURL=LayoutStrategyWithFallback.js.map